export const statusFilterKey = 'status';
export const APP_STORE_CATALOG_ID = 116;
export const CATALOGS_WITHOUT_MANUAL_MANAGEMENT = [
    -1, // TODO remove later
    // 116, // App Store
    // 117, // Play Market
];
